// @ts-nocheck
/* eslint-disable @typescript-eslint/no-unused-vars */
import * as Types from '../../../../api/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type BulkImportRowFragmentFragment = (
  { readonly __typename: 'BulkImportUserRow' }
  & Pick<Types.BulkImportUserRow, 'id' | 'rowNumber' | 'firstName' | 'lastName' | 'email' | 'userGroupName' | 'groupIsNew' | 'company' | 'outcome' | 'outcomeDetail' | 'invitationLink' | 'invitationAccepted' | 'emailSentAt'>
);

export type BulkImportRequestFragmentFragment = (
  { readonly __typename: 'BulkUserImportRequestType' }
  & Pick<Types.BulkUserImportRequestType, 'id' | 'fileName' | 'importedAt' | 'invitationsSentAt'>
  & { readonly rowCounts: (
    { readonly __typename: 'BulkImportRowCounts' }
    & Pick<Types.BulkImportRowCounts, 'newUser' | 'existingUserNewGroup' | 'noOp' | 'disabledUser' | 'error'>
  ), readonly rows: ReadonlyArray<(
    { readonly __typename: 'BulkImportUserRow' }
    & BulkImportRowFragmentFragment
  )> }
);

export type UploadBulkUserImportMutationVariables = Types.Exact<{
  orgSlug: Types.Scalars['String'];
  file: Types.Scalars['Upload'];
  roleId: Types.Scalars['ID'];
}>;


export type UploadBulkUserImportMutation = (
  { readonly __typename: 'Mutation' }
  & { readonly uploadBulkUserImport?: Types.Maybe<(
    { readonly __typename: 'UploadBulkUserImportPayload' }
    & { readonly request?: Types.Maybe<(
      { readonly __typename: 'BulkUserImportRequestType' }
      & BulkImportRequestFragmentFragment
    )>, readonly errors: ReadonlyArray<(
      { readonly __typename: 'BulkImportValidationError' }
      & Pick<Types.BulkImportValidationError, 'sheet' | 'row' | 'column' | 'message'>
    )> }
  )> }
);

export type ConfirmBulkUserImportMutationVariables = Types.Exact<{
  requestId: Types.Scalars['ID'];
}>;


export type ConfirmBulkUserImportMutation = (
  { readonly __typename: 'Mutation' }
  & { readonly confirmBulkUserImport?: Types.Maybe<(
    { readonly __typename: 'ConfirmBulkUserImportPayload' }
    & Pick<Types.ConfirmBulkUserImportPayload, 'errors'>
    & { readonly request?: Types.Maybe<(
      { readonly __typename: 'BulkUserImportRequestType' }
      & BulkImportRequestFragmentFragment
    )> }
  )> }
);

export type SendBulkInvitationEmailsMutationVariables = Types.Exact<{
  requestId: Types.Scalars['ID'];
  userRowIds: ReadonlyArray<Types.Scalars['ID']> | Types.Scalars['ID'];
}>;


export type SendBulkInvitationEmailsMutation = (
  { readonly __typename: 'Mutation' }
  & { readonly sendBulkInvitationEmails?: Types.Maybe<(
    { readonly __typename: 'SendBulkInvitationEmailsPayload' }
    & Pick<Types.SendBulkInvitationEmailsPayload, 'sentCount'>
    & { readonly request: (
      { readonly __typename: 'BulkUserImportRequestType' }
      & BulkImportRequestFragmentFragment
    ) }
  )> }
);

export type BulkUserImportsQueryVariables = Types.Exact<{
  orgSlug: Types.Scalars['String'];
  limit?: Types.Maybe<Types.Scalars['Int']>;
  offset?: Types.Maybe<Types.Scalars['Int']>;
}>;


export type BulkUserImportsQuery = (
  { readonly __typename: 'Query' }
  & { readonly bulkUserImports?: Types.Maybe<(
    { readonly __typename: 'BulkUserImportConnection' }
    & Pick<Types.BulkUserImportConnection, 'count'>
    & { readonly results: ReadonlyArray<(
      { readonly __typename: 'BulkUserImportRequestType' }
      & Pick<Types.BulkUserImportRequestType, 'id' | 'fileName' | 'importedAt' | 'invitationsSentAt'>
      & { readonly rowCounts: (
        { readonly __typename: 'BulkImportRowCounts' }
        & Pick<Types.BulkImportRowCounts, 'newUser' | 'existingUserNewGroup' | 'noOp' | 'disabledUser' | 'error'>
      ) }
    )> }
  )> }
);

export type BulkUserImportQueryVariables = Types.Exact<{
  requestId: Types.Scalars['ID'];
}>;


export type BulkUserImportQuery = (
  { readonly __typename: 'Query' }
  & { readonly bulkUserImport?: Types.Maybe<(
    { readonly __typename: 'BulkUserImportRequestType' }
    & BulkImportRequestFragmentFragment
  )> }
);

export const BulkImportRowFragmentFragmentDoc = gql`
    fragment BulkImportRowFragment on BulkImportUserRow {
  id
  rowNumber
  firstName
  lastName
  email
  userGroupName
  groupIsNew
  company
  outcome
  outcomeDetail
  invitationLink
  invitationAccepted
  emailSentAt
}
    `;
export const BulkImportRequestFragmentFragmentDoc = gql`
    fragment BulkImportRequestFragment on BulkUserImportRequestType {
  id
  fileName
  importedAt
  invitationsSentAt
  rowCounts {
    newUser
    existingUserNewGroup
    noOp
    disabledUser
    error
  }
  rows {
    ...BulkImportRowFragment
  }
}
    ${BulkImportRowFragmentFragmentDoc}`;
export const UploadBulkUserImportDocument = gql`
    mutation UploadBulkUserImport($orgSlug: String!, $file: Upload!, $roleId: ID!) {
  uploadBulkUserImport(orgSlug: $orgSlug, file: $file, roleId: $roleId) {
    request {
      ...BulkImportRequestFragment
    }
    errors {
      sheet
      row
      column
      message
    }
  }
}
    ${BulkImportRequestFragmentFragmentDoc}`;
export type UploadBulkUserImportMutationFn = Apollo.MutationFunction<UploadBulkUserImportMutation, UploadBulkUserImportMutationVariables>;

/**
 * __useUploadBulkUserImportMutation__
 *
 * To run a mutation, you first call `useUploadBulkUserImportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadBulkUserImportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadBulkUserImportMutation, { data, loading, error }] = useUploadBulkUserImportMutation({
 *   variables: {
 *      orgSlug: // value for 'orgSlug'
 *      file: // value for 'file'
 *      roleId: // value for 'roleId'
 *   },
 * });
 */
export function useUploadBulkUserImportMutation(baseOptions?: Apollo.MutationHookOptions<UploadBulkUserImportMutation, UploadBulkUserImportMutationVariables>) {
        return Apollo.useMutation<UploadBulkUserImportMutation, UploadBulkUserImportMutationVariables>(UploadBulkUserImportDocument, baseOptions);
      }
export type UploadBulkUserImportMutationHookResult = ReturnType<typeof useUploadBulkUserImportMutation>;
export type UploadBulkUserImportMutationResult = Apollo.MutationResult<UploadBulkUserImportMutation>;
export type UploadBulkUserImportMutationOptions = Apollo.BaseMutationOptions<UploadBulkUserImportMutation, UploadBulkUserImportMutationVariables>;
export const ConfirmBulkUserImportDocument = gql`
    mutation ConfirmBulkUserImport($requestId: ID!) {
  confirmBulkUserImport(requestId: $requestId) {
    request {
      ...BulkImportRequestFragment
    }
    errors
  }
}
    ${BulkImportRequestFragmentFragmentDoc}`;
export type ConfirmBulkUserImportMutationFn = Apollo.MutationFunction<ConfirmBulkUserImportMutation, ConfirmBulkUserImportMutationVariables>;

/**
 * __useConfirmBulkUserImportMutation__
 *
 * To run a mutation, you first call `useConfirmBulkUserImportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmBulkUserImportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmBulkUserImportMutation, { data, loading, error }] = useConfirmBulkUserImportMutation({
 *   variables: {
 *      requestId: // value for 'requestId'
 *   },
 * });
 */
export function useConfirmBulkUserImportMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmBulkUserImportMutation, ConfirmBulkUserImportMutationVariables>) {
        return Apollo.useMutation<ConfirmBulkUserImportMutation, ConfirmBulkUserImportMutationVariables>(ConfirmBulkUserImportDocument, baseOptions);
      }
export type ConfirmBulkUserImportMutationHookResult = ReturnType<typeof useConfirmBulkUserImportMutation>;
export type ConfirmBulkUserImportMutationResult = Apollo.MutationResult<ConfirmBulkUserImportMutation>;
export type ConfirmBulkUserImportMutationOptions = Apollo.BaseMutationOptions<ConfirmBulkUserImportMutation, ConfirmBulkUserImportMutationVariables>;
export const SendBulkInvitationEmailsDocument = gql`
    mutation SendBulkInvitationEmails($requestId: ID!, $userRowIds: [ID!]!) {
  sendBulkInvitationEmails(requestId: $requestId, userRowIds: $userRowIds) {
    sentCount
    request {
      ...BulkImportRequestFragment
    }
  }
}
    ${BulkImportRequestFragmentFragmentDoc}`;
export type SendBulkInvitationEmailsMutationFn = Apollo.MutationFunction<SendBulkInvitationEmailsMutation, SendBulkInvitationEmailsMutationVariables>;

/**
 * __useSendBulkInvitationEmailsMutation__
 *
 * To run a mutation, you first call `useSendBulkInvitationEmailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendBulkInvitationEmailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendBulkInvitationEmailsMutation, { data, loading, error }] = useSendBulkInvitationEmailsMutation({
 *   variables: {
 *      requestId: // value for 'requestId'
 *      userRowIds: // value for 'userRowIds'
 *   },
 * });
 */
export function useSendBulkInvitationEmailsMutation(baseOptions?: Apollo.MutationHookOptions<SendBulkInvitationEmailsMutation, SendBulkInvitationEmailsMutationVariables>) {
        return Apollo.useMutation<SendBulkInvitationEmailsMutation, SendBulkInvitationEmailsMutationVariables>(SendBulkInvitationEmailsDocument, baseOptions);
      }
export type SendBulkInvitationEmailsMutationHookResult = ReturnType<typeof useSendBulkInvitationEmailsMutation>;
export type SendBulkInvitationEmailsMutationResult = Apollo.MutationResult<SendBulkInvitationEmailsMutation>;
export type SendBulkInvitationEmailsMutationOptions = Apollo.BaseMutationOptions<SendBulkInvitationEmailsMutation, SendBulkInvitationEmailsMutationVariables>;
export const BulkUserImportsDocument = gql`
    query BulkUserImports($orgSlug: String!, $limit: Int, $offset: Int) {
  bulkUserImports(orgSlug: $orgSlug, limit: $limit, offset: $offset) {
    count
    results {
      id
      fileName
      importedAt
      invitationsSentAt
      rowCounts {
        newUser
        existingUserNewGroup
        noOp
        disabledUser
        error
      }
    }
  }
}
    `;

/**
 * __useBulkUserImportsQuery__
 *
 * To run a query within a React component, call `useBulkUserImportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBulkUserImportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBulkUserImportsQuery({
 *   variables: {
 *      orgSlug: // value for 'orgSlug'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useBulkUserImportsQuery(baseOptions: Apollo.QueryHookOptions<BulkUserImportsQuery, BulkUserImportsQueryVariables>) {
        return Apollo.useQuery<BulkUserImportsQuery, BulkUserImportsQueryVariables>(BulkUserImportsDocument, baseOptions);
      }
export function useBulkUserImportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BulkUserImportsQuery, BulkUserImportsQueryVariables>) {
          return Apollo.useLazyQuery<BulkUserImportsQuery, BulkUserImportsQueryVariables>(BulkUserImportsDocument, baseOptions);
        }
export type BulkUserImportsQueryHookResult = ReturnType<typeof useBulkUserImportsQuery>;
export type BulkUserImportsLazyQueryHookResult = ReturnType<typeof useBulkUserImportsLazyQuery>;
export type BulkUserImportsQueryResult = Apollo.QueryResult<BulkUserImportsQuery, BulkUserImportsQueryVariables>;
export const BulkUserImportDocument = gql`
    query BulkUserImport($requestId: ID!) {
  bulkUserImport(requestId: $requestId) {
    ...BulkImportRequestFragment
  }
}
    ${BulkImportRequestFragmentFragmentDoc}`;

/**
 * __useBulkUserImportQuery__
 *
 * To run a query within a React component, call `useBulkUserImportQuery` and pass it any options that fit your needs.
 * When your component renders, `useBulkUserImportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBulkUserImportQuery({
 *   variables: {
 *      requestId: // value for 'requestId'
 *   },
 * });
 */
export function useBulkUserImportQuery(baseOptions: Apollo.QueryHookOptions<BulkUserImportQuery, BulkUserImportQueryVariables>) {
        return Apollo.useQuery<BulkUserImportQuery, BulkUserImportQueryVariables>(BulkUserImportDocument, baseOptions);
      }
export function useBulkUserImportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BulkUserImportQuery, BulkUserImportQueryVariables>) {
          return Apollo.useLazyQuery<BulkUserImportQuery, BulkUserImportQueryVariables>(BulkUserImportDocument, baseOptions);
        }
export type BulkUserImportQueryHookResult = ReturnType<typeof useBulkUserImportQuery>;
export type BulkUserImportLazyQueryHookResult = ReturnType<typeof useBulkUserImportLazyQuery>;
export type BulkUserImportQueryResult = Apollo.QueryResult<BulkUserImportQuery, BulkUserImportQueryVariables>;